import { Flex, Spinner } from '@chakra-ui/react'
import { useMe } from 'hooks/useAuth'

const LoadMe = () => {
    useMe();

    return (
        <Flex w="full" h="100vh" justifyContent="center" alignItems="center">
            <Spinner size="xl" />
        </Flex>
    )
}

export default LoadMe